import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanKKBFinancial1Service from "services/Setup/LoanOrigination/Financial/ApkLoanKKBFinancial1Service";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingFinancial1: false,
  loadingFromInstallment: false,
  loadingConvertFlatToEffective: false,
  loadingInterestamount: false,
  calculateIntersetAmount: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  flatToEffective: [],
  effectiveToFlat: [],
  interestConversionData: [],
  interestamountItem: [],
  frominstallment: [],
  simulateFinancial1: [],
  totalInterest: {},
  monthlyInstallment: "",
  refreshList: false,
};

// 🔹 convertFlatToEffective Thunk
export const convertFlatToEffectiveSlice = createAsyncThunk(
  "ApkLoanKKBFinancial1/convertFlatToEffectiveSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKKBFinancial1Service.convertFlatToEffectiveService(
          userInput
        );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const convertEffectiveToFlatSlice = createAsyncThunk(
  "ApkLoanKKBFinancial1/convertEffectiveToFlatSlice",
  async (userInput, { rejectWithValue }) => {
    console.log("convertFlatToEffective", userInput);
    try {
      const response =
        await ApkLoanKKBFinancial1Service.convertEffectiveToFlatService(
          userInput
        );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const interestamountSlice = createAsyncThunk(
  "ApkLoanKKBFinancial1/interestamountSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKKBFinancial1Service.interestamountService(
        userInput
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const frominstallmentSlice = createAsyncThunk(
  "ApkLoanKKBFinancial1/frominstallmentSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKKBFinancial1Service.frominstallmentService(
        userInput
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const simulateSlice = createAsyncThunk(
  "ApkLoanKKBFinancial1/simulateSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKKBFinancial1Service.simulateService(
        userInput
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// 🔹 Slice
export const ApkLoanKKBFinancial1Slice = createSlice({
  name: "apkLoanKKBFinancial1",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetConversion: (state) => {
      state.interestConversionData = false;
      state.frominstallment = false;
    },
    resetDataFinancial1: (state) => {
      state.flatToEffective = [];
      state.effectiveToFlat = [];
      // state.interestConversionData = [];
      state.interestamountItem = [];
      state.totalInterest = {};
      state.monthlyInstallment = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(convertFlatToEffectiveSlice.pending, (state) => {
        state.loadingConvertFlatToEffective = true;
        state.interestConversionData = null;
      })
      .addCase(convertFlatToEffectiveSlice.fulfilled, (state, action) => {
        // console.log("codeConversi123cek", action.payload);

        state.loadingConvertFlatToEffective = false;
        state.interestConversionData = action.payload;
        state.frominstallment = null;
      })
      .addCase(convertFlatToEffectiveSlice.rejected, (state, action) => {
        state.loadingConvertFlatToEffective = false;
        state.result = action.payload;
        state.interestConversionData = null;
        state.showMessage = true;
      })
      //convertEffectiveToFlatSlice
      .addCase(convertEffectiveToFlatSlice.pending, (state) => {
        state.loadingConvertFlatToEffective = true;
        state.interestConversionData = null;
      })
      .addCase(convertEffectiveToFlatSlice.fulfilled, (state, action) => {
        console.log("codeConversi123", action.payload);

        state.loadingConvertFlatToEffective = false;
        state.interestConversionData = action.payload;
        state.frominstallment = null;
      })
      .addCase(convertEffectiveToFlatSlice.rejected, (state, action) => {
        state.loadingConvertFlatToEffective = false;
        state.result = action.payload;
        state.interestConversionData = null;
        state.showMessage = true;
      })
      // interestamountSlice
      .addCase(interestamountSlice.pending, (state) => {
        state.loadingInterestamount = true;
      })
      .addCase(interestamountSlice.fulfilled, (state, action) => {
        state.loadingInterestamount = false;
        state.calculateIntersetAmount = false;
        state.interestamountItem = action.payload;
      })
      .addCase(interestamountSlice.rejected, (state, action) => {
        state.loadingInterestamount = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // frominstallmentSlice
      .addCase(frominstallmentSlice.pending, (state) => {
        state.loadingFromInstallment = true;
      })
      .addCase(frominstallmentSlice.fulfilled, (state, action) => {
        state.loadingFromInstallment = false;
        state.frominstallment = action.payload;
        state.interestConversionData = null;
      })
      .addCase(frominstallmentSlice.rejected, (state, action) => {
        state.loadingFromInstallment = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // simulateSlice
      .addCase(simulateSlice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(simulateSlice.fulfilled, (state, action) => {
        state.loadingFinancial1 = false;
        state.simulateFinancial1 = action.payload;
      })
      .addCase(simulateSlice.rejected, (state, action) => {
        state.loadingFinancial1 = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

// 🔹 Export actions & reducer
export const {
  showNotification,
  hideNotification,
  showLoading,
  resetDataFinancial1,
  resetConversion,
} = ApkLoanKKBFinancial1Slice.actions;

export default ApkLoanKKBFinancial1Slice.reducer;
